<template>
  <div
    class="tw-justify-between tw-flex tw-items-center tw-rounded tw-w-full tw-py-2 tw-px-3"
    :class="[
      !disabled && duration && duration !== 0
        ? 'tw-bg-indigo-50 tw-text-indigo-500'
        : 'tw-text-gray-600 tw-bg-true-gray-200',
    ]"
  >
    <div>
      <WdsIcon v-show="duration && duration !== 0" name="timer" :size="16" />
    </div>
    {{ formatFixedDecimal(duration)
    }}{{
      timesheetFormStore.useDayInputs ? $t('d (day abbreviation)') : $t('h (hour abbreviation)')
    }}
  </div>
</template>

<script setup lang="ts">
import { watch, computed } from 'vue'
import { WdsIcon } from '@worksome/wds-components'
import { useTimesheetFormStore } from '@/components/Timesheet/store/useTimesheetFormStore'
import calculateHoursFromStartAndEndTime from '@/components/Timesheet/utilities/calculateHoursFromStartAndEndTime'
import { useTranslation } from '@/composables/translation'
import formatFixedDecimal from '@/components/Timesheet/utilities/formatFixedDecimal'

const { $t } = useTranslation()

interface Props {
  dateString: string
  startTime?: string
  endTime?: string
  breakHours?: number
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), { startTime: '', endTime: '', breakHours: 0 })

const timesheetFormStore = useTimesheetFormStore()

const duration = computed(() => {
  if (props.startTime && props.endTime) {
    return calculateHoursFromStartAndEndTime(props.startTime, props.endTime, props.breakHours)
  }
  return 0
})

watch(
  duration,
  (newDuration) => {
    timesheetFormStore.tableDateEntries[props.dateString].duration = newDuration
  },
  { immediate: true },
)
</script>
